import { immerable } from 'immer';
import { HouseDetail } from './HouseDetail';
import { HouseSummary, ApiResponseHouse } from './HouseSummary';
import { OwnerDetail } from './OwnerDetail';
import { OwnerSummary, ApiResponseOwner } from './OwnerSummary';
import { convertToDate, getDateFromDateTime, parseDateTimeWithOffset } from './utils/date';

export type PhotoSender = 'OWNER' | 'PHOTOGRAPHER';

const STATUS_WITH_PROBLEM = 'ComProblema';
export type SessionType = 'FLEXIBLE' | 'FIXED' | 'OWNER_PHOTOS';

export type ApiResponsePhotoSession = {
  id: number,
  property: ApiResponseHouse,
  owner: ApiResponseOwner,
  lockbox: boolean,
  keys: string,
  keysExtra: string,
  scheduledTo?: string,
  formattedHour: string,
  startTime?: string,
  delayedSession: boolean,
  notes: string,
  status: string,
  photoSender: PhotoSender,
  photosUploaded: boolean,
  photographerName: string,
  photographerRG: string,
  fixed: boolean,
  type: SessionType;
  rescheduleDeadline?: string,
}

export class PhotoSessionSummary {
  id: number;
  house: HouseSummary | HouseDetail;
  owner: OwnerSummary | OwnerDetail;
  dueDate: Date;
  fixed: boolean;
  photoSender: PhotoSender;
  status: string;
  type: SessionType;
  hasProblem: boolean;
  rescheduleDeadline: Date | null;

  [immerable] = true;

  constructor(apiPhotoSession: ApiResponsePhotoSession) {
    this.id = apiPhotoSession.id;
    this.house = new HouseSummary(apiPhotoSession.property);
    this.owner = new OwnerSummary(apiPhotoSession.owner);
    this.dueDate = this.createDueDate(apiPhotoSession);
    this.fixed = apiPhotoSession.fixed;
    this.status = apiPhotoSession.status;
    this.photoSender = apiPhotoSession.photoSender;
    this.type = apiPhotoSession.type;
    this.hasProblem = apiPhotoSession.status === STATUS_WITH_PROBLEM;
    this.rescheduleDeadline = parseDateTimeWithOffset(apiPhotoSession.rescheduleDeadline);
  }

  static createFrom(apiPhotoSession: ApiResponsePhotoSession): PhotoSessionSummary {
    return new PhotoSessionSummary(apiPhotoSession);
  }

  private createDueDate({ scheduledTo, formattedHour, fixed, startTime }: ApiResponsePhotoSession): Date {
    const zeroTime: string = '00:00';
    const startTimeDate = startTime || null;
    const dateString: string = scheduledTo || startTimeDate;

    const time: string = (fixed && formattedHour) ? formattedHour : zeroTime;
    const date: string = getDateFromDateTime({ dateString });

    return convertToDate({ date, time });
  }
}
